import Head from "next/head";
import { LayoutData } from "@types";
import Script from "next/script";
import 'sentry.client.config'
import { CardsSectionProps } from "../components/shared/CardsList/types";
import { useEffect, useState } from "react";
import axios from "axios";
import CategoryList from "../components/shared/CardsList";
import Hero from "../components/shared/Hero";
import { HeroProps } from "../components/shared/Hero/types";
import OverviewCardsHome from "../components/shared/OverviewCardsHome";
import { SimplySellMoreProps } from "../components/shared/SimplySellMore/types";
import SimplySellMore from "../components/shared/SimplySellMore";
import CustomCarousel, { CarouselProps } from "../components/shared/CustomCarousel";
import { RequestProductProps } from "../components/shared/RequestProduct/types";
import RequestProduct from "../components/shared/RequestProduct";
import PromotionHomePageBanner from "../components/shared/PromotionHomePageBanner";
import { getResourceId } from "../utilities/mapHubspotModules";
import { GetServerSideProps } from 'next';

type HomeProps = {
  layoutData: LayoutData;
  initialHubspotFieldsHero: HeroProps | null;
};

export default function Home({ layoutData, initialHubspotFieldsHero }: HomeProps) {
  console.log("[Home Component] Received initialHubspotFieldsHero:", JSON.stringify(initialHubspotFieldsHero, null, 2));
  const [hubspotFieldsCardSection1, setHubspotFieldsCardSection1] = useState<CardsSectionProps>();
  const [hubspotFieldsCardSection2, setHubspotFieldsCardSection2] = useState<CardsSectionProps>();
  const [hubspotFieldsCardSection3, setHubspotFieldsCardSection3] = useState<CardsSectionProps>();
  const [hubspotFieldsCardSection4, setHubspotFieldsCardSection4] = useState<CardsSectionProps>();
  const [hubspotFieldsCardSection5, setHubspotFieldsCardSection5] = useState<CardsSectionProps>();
  const [hubspotFieldsHero, setHubspotFieldsHero] = useState<HeroProps | undefined>(initialHubspotFieldsHero ?? undefined);
  const [hubspotFieldsSimplySellMore, setHubspotFieldsSimplySellMore] = useState<SimplySellMoreProps>();
  const [hubspotFieldsCarousel1, setHubspotFieldsCarousel1] = useState<CarouselProps>();
  const [hubspotFieldsCarousel2, setHubspotFieldsCarousel2] = useState<CarouselProps>();
  const [hubspotFieldsCarousel3, setHubspotFieldsCarousel3] = useState<CarouselProps>();
  const [hubspotFieldsCarousel4, setHubspotFieldsCarousel4] = useState<CarouselProps>();
  const [hubspotFieldsCarousel5, setHubspotFieldsCarousel5] = useState<CarouselProps>();
  const [hubspotFieldsRequestProduct, setHubspotFieldsRequestProduct] = useState<RequestProductProps>();

  const [isLoadingBelowFold, setIsLoadingBelowFold] = useState(true); 
 
  useEffect(() => {
    const fetchCardSection1Data = async () => {
      try {
        const { data } = await axios.get(`/api/hubspot-cms/cardSection-cms?rowId=${getResourceId("rows", "cardSectionWelcomeBack")}`);
        setHubspotFieldsCardSection1(data.fieldPlaceholders);
      } catch (error) {
        if (axios.isAxiosError(error)) {
          console.error("Error fetching HubSpot CardSection1 data :", error.message);
        } else {
          console.error("Error fetching HubSpot CardSection1 data:", error);
        }
      }
    };
    if (!hubspotFieldsCardSection1) {
        fetchCardSection1Data();
    }
}, [hubspotFieldsCardSection1]);

const DELAY_MS = 2000;

const createDelayedFetcher = (setter: Function, apiPath: string, stateValue: any, debugName: string) => {
    if (!stateValue) {
        const timerId = setTimeout(async () => {
            console.log(`[Delayed Fetch] Starting fetch for ${debugName}`);
            try {
                const { data } = await axios.get(apiPath);
                setter(data.fieldPlaceholders);
            } catch (error) {
                if (axios.isAxiosError(error)) {
                    console.error(`Error fetching HubSpot ${debugName} data :`, error.message);
                } else {
                    console.error(`Error fetching HubSpot ${debugName} data:`, error);
                }
            }
        }, DELAY_MS);
        return () => clearTimeout(timerId);
    }
    return () => {};
};

useEffect(() => createDelayedFetcher(setHubspotFieldsCardSection2, `/api/hubspot-cms/cardSection-cms?rowId=${getResourceId("rows", "cardSectionTopCategories")}`, hubspotFieldsCardSection2, "CardSection2"), [hubspotFieldsCardSection2]);
useEffect(() => createDelayedFetcher(setHubspotFieldsCardSection3, `/api/hubspot-cms/cardSection-cms?rowId=${getResourceId("rows", "cardSectionShopByBrands1")}`, hubspotFieldsCardSection3, "CardSection3"), [hubspotFieldsCardSection3]);
useEffect(() => createDelayedFetcher(setHubspotFieldsCardSection4, `/api/hubspot-cms/cardSection-cms?rowId=${getResourceId("rows", "cardSectionShopByBrands2")}`, hubspotFieldsCardSection4, "CardSection4"), [hubspotFieldsCardSection4]);
useEffect(() => createDelayedFetcher(setHubspotFieldsCardSection5, `/api/hubspot-cms/cardSection-cms?rowId=${getResourceId("rows", "cardSectionShopByBusiness")}`, hubspotFieldsCardSection5, "CardSection5"), [hubspotFieldsCardSection5]);
useEffect(() => createDelayedFetcher(setHubspotFieldsSimplySellMore, "/api/hubspot-cms/homeSymplySellMore-cms", hubspotFieldsSimplySellMore, "SimplySellMore"), [hubspotFieldsSimplySellMore]);
useEffect(() => createDelayedFetcher(setHubspotFieldsCarousel1, `/api/hubspot-cms/carrousel-cms?rowId=${getResourceId("rows", "carouselFeaturedProductsHome")}`, hubspotFieldsCarousel1, "Carousel1"), [hubspotFieldsCarousel1]);
useEffect(() => createDelayedFetcher(setHubspotFieldsCarousel2, `/api/hubspot-cms/carrousel-cms?rowId=${getResourceId("rows", "carouselHaggleProducts")}`, hubspotFieldsCarousel2, "Carousel2"), [hubspotFieldsCarousel2]);
useEffect(() => createDelayedFetcher(setHubspotFieldsCarousel3, `/api/hubspot-cms/carrousel-cms?rowId=${getResourceId("rows", "CarouselPopularThisMonth")}`, hubspotFieldsCarousel3, "Carousel3"), [hubspotFieldsCarousel3]);
useEffect(() => createDelayedFetcher(setHubspotFieldsCarousel4, `/api/hubspot-cms/carrousel-cms?rowId=${getResourceId("rows", "CarouselFeaturedProduct2")}`, hubspotFieldsCarousel4, "Carousel4"), [hubspotFieldsCarousel4]);
useEffect(() => createDelayedFetcher(setHubspotFieldsCarousel5, `/api/hubspot-cms/carrousel-cms?rowId=${getResourceId("rows", "CarouselRecentlyViewed")}`, hubspotFieldsCarousel5, "Carousel5"), [hubspotFieldsCarousel5]);

useEffect(() => {
    if (!hubspotFieldsRequestProduct) {
        const timerId = setTimeout(async () => {
            console.log("[Delayed Fetch] Starting fetch for RequestProduct");
            try {
                const { data } = await axios.get("/api/hubspot-cms/requestProduct-cms");
                setHubspotFieldsRequestProduct(data.fieldPlaceholders);
            } catch (error) {
                if (axios.isAxiosError(error)) {
                    console.error("Error fetching HubSpot RequestProduct data :", error.message);
                } else {
                    console.error("Error fetching HubSpot RequestProduct data:", error);
                }
            } finally {
                setIsLoadingBelowFold(false);
            }
        }, DELAY_MS + 200);
        return () => clearTimeout(timerId);
    }
    return () => {};
}, [hubspotFieldsRequestProduct]);

  return (
    <>
      <Head>
        <title>Epallet</title>
        <meta
          name="description"
          content="Shop at EPallet for the widest selection and best variety."
        />
        <meta name="viewport" content="width=device-width" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin=""
        />
        {/* <link href="https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap" rel="stylesheet" /> */}
        <Script>
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer',${process.env.NEXT_PUBLIC_GTM_ID});
          `}
        </Script>
      </Head>
      {/* <body>
        <noscript>
          <iframe
            src={`https://www.googletagmanager.com/ns.html?id=${process.env.NEXT_PUBLIC_GTM_ID}`}
            height="0"
            width="0"
            style={{ display: "none", visibility: "hidden" }}
          ></iframe>
        </noscript>
      </body> */}
      <main style={{ padding: 0 }} role="main">
        {/*<DynamicLayout data={layoutData} />  */}
        {hubspotFieldsCardSection1 && <CategoryList {...hubspotFieldsCardSection1} />}
        {hubspotFieldsHero && hubspotFieldsHero.image && hubspotFieldsHero.mobileImage && (
          <Hero
            image={hubspotFieldsHero.image}
            mobileImage={hubspotFieldsHero.mobileImage}
            heading={hubspotFieldsHero.heading}
            subHeading={hubspotFieldsHero.subHeading}
            linkLabel={hubspotFieldsHero.linkLabel}
            linkLabelMobile={hubspotFieldsHero.linkLabelMobile}
            linkUrl={hubspotFieldsHero.linkUrl}
            AllowedUsers={hubspotFieldsHero.AllowedUsers}
            promotionID={hubspotFieldsHero.promotionID}
          />
        )}
        <OverviewCardsHome />
        {hubspotFieldsCardSection2 && <CategoryList {...hubspotFieldsCardSection2} />}
        {hubspotFieldsSimplySellMore && hubspotFieldsSimplySellMore.image && <SimplySellMore {...hubspotFieldsSimplySellMore} />}
        {hubspotFieldsCarousel1 && <CustomCarousel {...hubspotFieldsCarousel1} />}
        {/* {hubspotFieldsCarousel2 && <CustomCarousel {...hubspotFieldsCarousel2} />} */}
        {hubspotFieldsCardSection3 && <CategoryList {...hubspotFieldsCardSection3} />}
        {hubspotFieldsCardSection4 && <CategoryList {...hubspotFieldsCardSection4} />}
        {hubspotFieldsCarousel3 && <CustomCarousel {...hubspotFieldsCarousel3} />}
        {hubspotFieldsCarousel4 && <CustomCarousel {...hubspotFieldsCarousel4} />}
        {hubspotFieldsCardSection5 && <CategoryList {...hubspotFieldsCardSection5} />}
        {hubspotFieldsCarousel5 && <CustomCarousel {...hubspotFieldsCarousel5} />}
        <PromotionHomePageBanner />
        {hubspotFieldsRequestProduct && <RequestProduct {...hubspotFieldsRequestProduct} />}
        
      </main>
    </>
  );
}

export const getServerSideProps: GetServerSideProps<HomeProps> = async (context) => {
  console.log("[getServerSideProps] Starting...");
  const startTime = Date.now();
  let initialHubspotFieldsHero: HeroProps | null = null;
  const layoutData = {} as LayoutData;

  const desktopImageWidth = 3200;
  const desktopImageHeight = 1106;
  const mobileImageWidth = 375;
  const mobileImageHeight = 388;

  try {
    const protocol = context.req.headers['x-forwarded-proto'] || 'http';
    const host = context.req.headers.host;
    const heroApiUrl = `${protocol}://${host}/api/hubspot-cms/hero-cms`;
    console.log(`[getServerSideProps] Fetching Hero data from: ${heroApiUrl}`);
    
    const response = await axios.get(heroApiUrl);
    const fetchTime = Date.now();
    console.log(`[getServerSideProps] API call took: ${fetchTime - startTime}ms`);

    if (response.data && response.data.fieldPlaceholders) {
      let heroData = response.data.fieldPlaceholders;

      // Hardcode dimensions if they are missing
      if (heroData.image) {
        heroData.image.width = heroData.image.width || desktopImageWidth;
        heroData.image.height = heroData.image.height || desktopImageHeight;
      } else {
        // If image object itself is missing, create it with hardcoded values
        // This might be an issue if URL/altText are also missing, but we prioritize dimensions for next/image
        console.warn("[getServerSideProps] Hero Desktop Image object was missing. Creating with hardcoded dimensions.");
        heroData.image = { url: '', altText: '', width: desktopImageWidth, height: desktopImageHeight }; 
      }

      if (heroData.mobileImage) {
        heroData.mobileImage.width = heroData.mobileImage.width || mobileImageWidth;
        heroData.mobileImage.height = heroData.mobileImage.height || mobileImageHeight;
      } else {
        console.warn("[getServerSideProps] Hero Mobile Image object was missing. Creating with hardcoded dimensions.");
        heroData.mobileImage = { url: '', altText: '', width: mobileImageWidth, height: mobileImageHeight };
      }
      
      initialHubspotFieldsHero = heroData;
      console.log("[getServerSideProps] Successfully fetched and processed Hero data:", JSON.stringify(initialHubspotFieldsHero, null, 2));
      
      // Re-log critical dimension info after potential hardcoding
      if (initialHubspotFieldsHero?.image) {
        console.log("[getServerSideProps] POST-HARDCODE Hero Desktop Image URL:", initialHubspotFieldsHero.image.url);
        console.log("[getServerSideProps] POST-HARDCODE Hero Desktop Image Width:", initialHubspotFieldsHero.image.width);
        console.log("[getServerSideProps] POST-HARDCODE Hero Desktop Image Height:", initialHubspotFieldsHero.image.height);
      } else {
        console.warn("[getServerSideProps] POST-HARDCODE Hero Desktop Image data is still missing or incomplete.");
      }
      if (initialHubspotFieldsHero?.mobileImage) {
        console.log("[getServerSideProps] POST-HARDCODE Hero Mobile Image URL:", initialHubspotFieldsHero.mobileImage.url);
        console.log("[getServerSideProps] POST-HARDCODE Hero Mobile Image Width:", initialHubspotFieldsHero.mobileImage.width);
        console.log("[getServerSideProps] POST-HARDCODE Hero Mobile Image Height:", initialHubspotFieldsHero.mobileImage.height);
      } else {
        console.warn("[getServerSideProps] POST-HARDCODE Hero Mobile Image data is still missing or incomplete.");
      }

    } else {
      console.error("[getServerSideProps] Hero data fetched is not in expected format:", response.data);
      initialHubspotFieldsHero = null;
    }
  } catch (error) {
    const errorTime = Date.now();
    console.error(`[getServerSideProps] Error fetching Hero data after ${errorTime - startTime}ms.`);
    if (axios.isAxiosError(error)) {
      console.error("[getServerSideProps] Axios error details:", error.message, error.config?.url);
    } else {
      console.error("[getServerSideProps] Generic error details:", error);
    }
    // If there's an error, create hero data with empty URLs but hardcoded dimensions so next/image doesn't break
    // and so that space is at least reserved on the page.
    console.warn("[getServerSideProps] Error occurred, falling back to hero data with empty URLs and hardcoded dimensions.");
    initialHubspotFieldsHero = {
      image: { url: '', altText: 'Error loading image', width: desktopImageWidth, height: desktopImageHeight },
      mobileImage: { url: '', altText: 'Error loading image', width: mobileImageWidth, height: mobileImageHeight },
      heading: 'Hero Content Unavailable',
      subHeading: '',
      linkLabel: '',
      linkLabelMobile: '',
      linkUrl: '#',
      AllowedUsers: 'Guest',
      promotionID: 0
    };
  }

  const endTime = Date.now();
  console.log(`[getServerSideProps] Finished. Total time: ${endTime - startTime}ms`);

  return {
    props: {
      layoutData,
      initialHubspotFieldsHero,
    },
  };
};
